// extracted by mini-css-extract-plugin
export default {"infoContainer":"phonenumber_infoContainer__r4e5y"};